/**
 * Constants for the My Writing feature
 */

export const GENRES = [
  'Fiction',
  'Fantasy',
  'Science Fiction',
  'Romance',
  'Mystery',
  'Thriller',
  'Horror',
  'Poetry',
  'Contemporary',
  'Historical Fiction',
  'Literary Fiction',
  'Young Adult',
  'Non-Fiction',
  'Memoir',
  'Other',
];

export const STATUS = {
  draft: { value: 'draft', label: 'Draft' },
  completed: { value: 'completed', label: 'Completed' },
  published: { value: 'published', label: 'Published' },
  archived: { value: 'archived', label: 'Archived' },
};

export const VISIBILITY_META = {
  private: {
    value: 'private',
    label: 'Private',
    hint: 'Only you can see this story.',
  },
  unlisted: {
    value: 'unlisted',
    label: 'Unlisted',
    hint: 'Anyone with the link can read it.',
  },
  published: {
    value: 'published',
    label: 'Published',
    hint: 'Visible to the whole ScribbleReads community.',
  },
};

export const DASHBOARD_TABS = [
  { key: 'all', label: 'All Manuscripts' },
  { key: 'draft', label: 'Drafts' },
  { key: 'published', label: 'Published' },
  { key: 'archived', label: 'Archived' },
];

export const SORT_OPTIONS = [
  { value: 'updatedAt', label: 'Recently Edited' },
  { value: 'createdAt', label: 'Recently Created' },
  { value: 'title', label: 'Title (A-Z)' },
  { value: 'wordCount', label: 'Word Count' },
];

export const COVER_TONES = [
  { key: 'coral', from: '#CC6F69', to: '#B85E58' },
  { key: 'yellow', from: '#F0C77F', to: '#E0B164' },
  { key: 'sage', from: '#C5D7BD', to: '#A9C39D' },
  { key: 'blue', from: '#8196A1', to: '#6B808B' },
];

export const EMPTY_STATE_MESSAGES = {
  noStories: {
    heading: 'Every story starts somewhere.',
    subheading: 'Your next manuscript is one page away.',
    cta: 'Start Writing',
  },
  inProgress: {
    heading: 'Your manuscripts are still becoming stories.',
    subheading: "That's alright — good ones take their time.",
    cta: '+ New Manuscript',
  },
  draft: {
    heading: 'No drafts right now.',
    subheading: 'Ideas waiting to be written live here.',
    cta: '+ New Manuscript',
  },
  published: {
    heading: "You haven't published anything yet.",
    subheading: 'When a manuscript feels ready, share it with readers.',
    cta: null,
  },
  archived: {
    heading: 'Nothing archived.',
    subheading: 'Manuscripts you set aside will collect here.',
    cta: null,
  },
  search: {
    heading: 'No manuscripts found.',
    subheading: 'Try a different search term.',
    cta: null,
  },
};

export const AUTOSAVE_DELAY_MS = 700;

export const DEFAULT_CHAPTER_TITLE = 'Untitled Chapter';

export const WORDS_PER_MINUTE = 200;

export const IMPORT_ACCEPTED_TYPES = ['.txt', '.md'];
